import { createClient } from '@/shared/api';
import DEVICE_EVENT_COUNT_QUERY from '@/entities/strip/api/queries/deviceEventsCountV2';
import type {
  DeviceEventsCountV2Query,
  DeviceEventsCountV2QueryVariables,
} from '@/shared/api/generated/graphql';

export type DeviceEventsCountV2Result = {
  notificationEvents: number;
  patientTriggeredEvents: number;
  otherEvents: number;
};

// TODO(ts): typed as the DeviceEventsInput GraphQL input once its server-side shape is documented
/**
 * Counts the device events matching a filter so the list can paginate. Creates an Apollo client honoring the cache flag and runs the count query, returning its deviceEventsCountV2 field.
 *
 * @param filter - Server-side filter for the device events.
 * @param isUsingCache - Whether the Apollo client should serve from cache.
 * @returns A promise resolving to the deviceEventsCountV2 result.
 */
const fetchDeviceEventsCountV2 = async (filter: any, isUsingCache?: boolean) => {
  const client = await createClient(isUsingCache);
  const result = await client.query<DeviceEventsCountV2Query, DeviceEventsCountV2QueryVariables>({
    query: DEVICE_EVENT_COUNT_QUERY,
    variables: {
      filter,
    },
  });
  const { data } = result || {};
  const { deviceEventsCountV2 } = data || {};
  return deviceEventsCountV2;
};

export default fetchDeviceEventsCountV2;
